/* esm.sh - rxjs@7.8.2/dist/esm/internal/operators/endWith */
import{concat as t}from"rxjs/dist/esm/internal/observable/concat";import{of as n}from"rxjs/dist/esm/internal/observable/of";function m(...o){return r=>t(r,n(...o))}export{m as endWith};
//# sourceMappingURL=endWith.mjs.map